var render = function render(){var _vm=this,_c=_vm._self._c;return _c('APCDelconEditAdmin',{attrs:{"APCD":_vm.APCD,"ordersFBM":_vm.ordersFBM,"shippingCompanies":_vm.shippingCompanies},on:{"saveAPCDelcon":_vm.saveAPCDelcon}})
}
var staticRenderFns = []

export { render, staticRenderFns }